export class OpenAIProvider {
  constructor({ baseURL, apiKey, model, temperature = 0.7 }) {
    this.baseURL = (baseURL || 'https://api.openai.com/v1').replace(/\/$/, '');
    this.apiKey = apiKey;
    this.model = model;
    this.temperature = temperature;
  }

  async send(messages, { responseFormat } = {}) {
    const url = `${this.baseURL}/chat/completions`;
    const body = {
      model: this.model,
      messages,
      temperature: this.temperature,
      stream: false,
      ...(responseFormat ? { response_format: responseFormat } : {}),
    };

    let res;
    try {
      res = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.apiKey}`,
        },
        body: JSON.stringify(body),
      });
    } catch (err) {
      const error = new Error(`Network error: ${err.message}`);
      error.name = 'TypeError';
      throw error;
    }

    if (!res.ok) {
      const text = await res.text().catch(() => 'Unknown error');
      const error = new Error(`OpenAI API error ${res.status}: ${text}`);
      error.status = res.status;
      throw error;
    }

    const data = await res.json();
    return data.choices?.[0]?.message?.content ?? '';
  }
}
